import type { Router } from 'vue-router';
import { isOperationGuideKey } from './keys';

export const OPERATION_GUIDE_QUERY = 'operationguide';

export { isOperationGuideKey };

function pickQueryValue(raw: unknown): string | undefined {
  if (typeof raw === 'string' && raw) return raw;
  if (Array.isArray(raw) && typeof raw[0] === 'string' && raw[0]) return raw[0];
  return undefined;
}

/**
 * 全局监听路由 query `?operationguide=xxxx`。
 * 仅注册监听（轻量进入口）；open / modal / guides 均在触发时动态加载。
 */
export function setupOperationGuide(router: Router) {
  let opening = false;

  router.afterEach(async (to) => {
    const raw = pickQueryValue(to.query[OPERATION_GUIDE_QUERY]);
    if (!raw || !isOperationGuideKey(raw) || opening) return;

    opening = true;
    try {
      const nextQuery = { ...to.query };
      delete nextQuery[OPERATION_GUIDE_QUERY];
      await router.replace({
        path: to.path,
        query: nextQuery,
        hash: to.hash,
      });

      // 动态分包：open → modal.vue（含 guides / 样式），不进入口 chunk
      const { openOperationGuideModal } = await import(
        /* webpackChunkName: "operation-guide" */ './open'
      );
      await openOperationGuideModal({ guideKey: raw });
    } finally {
      opening = false;
    }
  });
}
